'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421 from "./presto.types$-Envelope-Title$$anon$21.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422 from "./presto.types$-Envelope-Title$$anon$22.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeTitle$() {
  this.c7x = null;
  this.c7y = false;
  this.c7v = null;
  this.c7w = false;
  this.c7z = null;
  this.c7A = false;
  this.c7B = null;
  this.c7C = false;
}
export { $c_Lpresto_types$EnvelopeTitle$ as $c_Lpresto_types$EnvelopeTitle$ };
$p = $c_Lpresto_types$EnvelopeTitle$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeTitle$;
/** @constructor */
function $h_Lpresto_types$EnvelopeTitle$() {
}
export { $h_Lpresto_types$EnvelopeTitle$ as $h_Lpresto_types$EnvelopeTitle$ };
$h_Lpresto_types$EnvelopeTitle$.prototype = $p;
$p.cJ5 = (function() {
  if ((!this.c7y)) {
    this.c7x = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7y = true;
  }
  return this.c7x;
});
$p.nM = (function() {
  if ((!this.c7w)) {
    this.c7v = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c7w = true;
  }
  return this.c7v;
});
$p.cJx = (function() {
  if ((!this.c7A)) {
    this.c7z = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421.$c_Lpresto_types$EnvelopeTitle$$anon$21(this);
    this.c7A = true;
  }
  return this.c7z;
});
$p.cK2 = (function() {
  if ((!this.c7C)) {
    this.c7B = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422.$c_Lpresto_types$EnvelopeTitle$$anon$22(this);
    this.c7C = true;
  }
  return this.c7B;
});
var $d_Lpresto_types$EnvelopeTitle$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeTitle$, "presto.types$EnvelopeTitle$", ({
  a0a: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeTitle$ as $d_Lpresto_types$EnvelopeTitle$ };
var $n_Lpresto_types$EnvelopeTitle$;
function $m_Lpresto_types$EnvelopeTitle$() {
  if ((!$n_Lpresto_types$EnvelopeTitle$)) {
    $n_Lpresto_types$EnvelopeTitle$ = new $c_Lpresto_types$EnvelopeTitle$();
  }
  return $n_Lpresto_types$EnvelopeTitle$;
}
export { $m_Lpresto_types$EnvelopeTitle$ as $m_Lpresto_types$EnvelopeTitle$ };
//# sourceMappingURL=presto.types$-Envelope-Title$.js.map
